import store from "../store";
import axios from "axios";

class Shares {

	async list(share_type, element_type = null)
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/share/list",
					{
						share_type,
						element_type
                    },
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data.shares);
				})
				.catch(function (error) {
					reject(error);
                });
            });
	}

	async list_share()
	{
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.get(
					`${process.env.VUE_APP_SAAS_BACK}` + "/share",
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data.shares);
				})
				.catch(function (error) {
					reject(error);
                });
            });
	}

	async post(share_type, element_type, element_uid, details = {}, automatic = false) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/share",
					{
						share: {share_type, element_type, element_uid, details},
						automatic
                    },
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
                });
            });
	}

	async delete(share_type, element_uid, automatic) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/share/delete",
					{
						share: {share_type, element_uid},
						automatic
                    },
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
                });
            });
	}
}

export default new Shares();
